import axios, { AxiosHeaders } from 'axios';
import { header } from '../../../components/header.encry';

const applyDefaultHeaders = (headers: AxiosHeaders) => {
  if (!headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  if (!headers.has('ENCRYKEY')) {
    const key =
      process.env.REACT_APP_KEY_PEGASUS || process.env.REACT_APP_KEY_PEGASUS_PUBLIC || undefined;

    if (key) {
      headers.set('ENCRYKEY', key);
    }
  }

  const authHeaders = header().headers || {};
  Object.entries(authHeaders).forEach(([key, value]) => {
    if (!headers.has(key) && value) {
      headers.set(key, value as string);
    }
  });
};

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_PEGASUS_API_URL || '',
  timeout: 15000,
});

apiClient.interceptors.request.use((config) => {
  const headers = AxiosHeaders.from(config.headers);

  applyDefaultHeaders(headers);

  config.headers = headers;
  return config;
});

apiClient.interceptors.response.use(
  (r) => r,
  (error) => {
    const message =
      error?.response?.data?.message || error?.response?.data?.error || 'Une erreur est survenue';
    return Promise.reject(new Error(message));
  }
);
